import React, { useState } from 'react';
import { Container, Row, Col, Card, Table, Badge, Form, Button, InputGroup, Modal, Pagination } from 'react-bootstrap';
import { Search, Filter, Eye, Download, Users, TrendingUp, DollarSign, Mail, Phone, MapPin, Calendar, Award, ToggleLeft, ToggleRight } from 'lucide-react';
import '../../../../assets/css/admin/dashboardCSS/DonorList.css';
import Adminlayout from '../../../../layouts/admin/Adminlayout';
import TitleBar from '../../../../subscreens/admin/TitleBar';

const DonorList = () => {
  // State Management
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedDonor, setSelectedDonor] = useState(null);
  const [showAllDonors, setShowAllDonors] = useState(false);

  const itemsPerPage = 9;

  // Donors Data
  const [donors, setDonors] = useState([
    {
      id: 'DNR-101',
      name: 'Ahmed Khan',
      email: 'ahmed@gmail.com',
      phone: '0300-1234567',
      address: 'House 123, Street 45, Lahore',
      totalDonations: 50000,
      numberOfDonations: 5,
      level: 'Gold',
      status: 'Active',
      joinedDate: '2024-01-15',
      lastDonation: '2025-08-12',
      preferredCategory: 'Fee',
      paymentMethod: 'Bank Transfer'
    },
    {
      id: 'DNR-102',
      name: 'Fatima Ali',
      email: 'fatima@gmail.com',
      phone: '0301-9876543',
      address: 'House 456, Street 78, Karachi',
      totalDonations: 30000,
      numberOfDonations: 3,
      level: 'Silver',
      status: 'Inactive',
      joinedDate: '2024-02-20',
      lastDonation: '2025-05-10',
      preferredCategory: 'Books',
      paymentMethod: 'Cash'
    },
    {
      id: 'DNR-103',
      name: 'Ali Raza',
      email: 'ali@gmail.com',
      phone: '0302-5551234',
      address: 'House 789, Street 12, Islamabad',
      totalDonations: 10000,
      numberOfDonations: 2,
      level: 'Bronze',
      status: 'Active',
      joinedDate: '2024-03-10',
      lastDonation: '2025-08-20',
      preferredCategory: 'Uniform',
      paymentMethod: 'Online'
    },
    {
      id: 'DNR-104',
      name: 'Sara Ahmed',
      email: 'sara@gmail.com',
      phone: '0303-7778888',
      address: 'House 321, Street 99, Lahore',
      totalDonations: 75000,
      numberOfDonations: 8,
      level: 'Platinum',
      status: 'Active',
      joinedDate: '2023-12-05',
      lastDonation: '2025-08-25',
      preferredCategory: 'Fee',
      paymentMethod: 'Bank Transfer'
    },
    {
      id: 'DNR-105',
      name: 'Hassan Malik',
      email: 'hassan@gmail.com',
      phone: '0304-4445555',
      address: 'House 654, Street 33, Faisalabad',
      totalDonations: 20000,
      numberOfDonations: 4,
      level: 'Silver',
      status: 'Active',
      joinedDate: '2024-04-18',
      lastDonation: '2025-08-15',
      preferredCategory: 'Books',
      paymentMethod: 'Cash'
    },
    {
      id: 'DNR-106',
      name: 'Zainab Hussain',
      email: 'zainab@gmail.com',
      phone: '0305-1112222',
      address: 'House 987, Street 66, Multan',
      totalDonations: 45000,
      numberOfDonations: 6,
      level: 'Gold',
      status: 'Active',
      joinedDate: '2024-01-25',
      lastDonation: '2025-08-18',
      preferredCategory: 'Fee',
      paymentMethod: 'Online'
    },
    {
      id: 'DNR-107',
      name: 'Bilal Mahmood',
      email: 'bilal@gmail.com',
      phone: '0306-3334444',
      address: 'House 147, Street 88, Rawalpindi',
      totalDonations: 15000,
      numberOfDonations: 3,
      level: 'Bronze',
      status: 'Inactive',
      joinedDate: '2024-05-12',
      lastDonation: '2025-06-20',
      preferredCategory: 'Uniform',
      paymentMethod: 'Bank Transfer'
    },
    {
      id: 'DNR-108',
      name: 'Ayesha Tariq',
      email: 'ayesha@gmail.com',
      phone: '0307-5556666',
      address: 'House 258, Street 22, Peshawar',
      totalDonations: 60000,
      numberOfDonations: 7,
      level: 'Platinum',
      status: 'Active',
      joinedDate: '2023-11-30',
      lastDonation: '2025-08-22',
      preferredCategory: 'Books',
      paymentMethod: 'Online'
    },
    {
      id: 'DNR-109',
      name: 'Usman Farooq',
      email: 'usman@gmail.com',
      phone: '0308-7778888',
      address: 'House 369, Street 44, Sialkot',
      totalDonations: 25000,
      numberOfDonations: 4,
      level: 'Silver',
      status: 'Active',
      joinedDate: '2024-02-14',
      lastDonation: '2025-08-10',
      preferredCategory: 'Fee',
      paymentMethod: 'Cash'
    },
    {
      id: 'DNR-110',
      name: 'Maryam Noor',
      email: 'maryam@gmail.com',
      phone: '0309-9990000',
      address: 'House 741, Street 55, Gujranwala',
      totalDonations: 35000,
      numberOfDonations: 5,
      level: 'Gold',
      status: 'Inactive',
      joinedDate: '2024-03-22',
      lastDonation: '2025-07-05',
      preferredCategory: 'Uniform',
      paymentMethod: 'Bank Transfer'
    }
  ]);

  // Calculate Stats
  const stats = {
    totalDonors: donors.length,
    activeDonors: donors.filter(d => d.status === 'Active').length,
    inactiveDonors: donors.filter(d => d.status === 'Inactive').length,
    totalDonationsAmount: donors.reduce((sum, d) => sum + d.totalDonations, 0)
  };

  // Filter Donors
  const filteredDonors = donors.filter(donor => {
    const matchesSearch = 
      donor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      donor.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      donor.id.toLowerCase().includes(searchQuery.toLowerCase());
    
    const matchesFilter = filterStatus === 'All' || donor.status === filterStatus;
    
    return matchesSearch && matchesFilter;
  });

  // Pagination Logic
  const totalPages = Math.ceil(filteredDonors.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDonors = showAllDonors 
    ? filteredDonors 
    : filteredDonors.slice(indexOfFirstItem, indexOfLastItem);

  // Handlers
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleViewDetails = (donor) => {
    setSelectedDonor(donor);
    setShowDetailModal(true);
  };

  // ✅ NEW: Toggle Active/Inactive Status
  const handleToggleStatus = (donorId) => {
    setDonors(prev => prev.map(donor =>
      donor.id === donorId
        ? { ...donor, status: donor.status === 'Active' ? 'Inactive' : 'Active' }
        : donor
    ));
  };

  const handleExport = () => {
    console.log('Exporting donors data...');
    alert('CSV export started!');
  };

  const handleViewAll = () => {
    setShowAllDonors(!showAllDonors);
    setCurrentPage(1);
  };

  const getStatusBadge = (status) => {
    return status === 'Active' ? 'success' : 'secondary';
  };

  const getLevelBadge = (level) => {
    const levelStyles = {
      'Bronze': 'dl-level-bronze',
      'Silver': 'dl-level-silver',
      'Gold': 'dl-level-gold',
      'Platinum': 'dl-level-platinum'
    };
    return levelStyles[level] || 'dl-level-bronze';
  };

  return (
    <Adminlayout>
    <div className="dl-donor-management-page">
      <Container fluid>
        {/* Page Header */}
      <TitleBar
                title="Donors List"
                subtitle="Manage and track all donors"
              ></TitleBar>
        {/* Stats Cards */}
        <Row className="dl-donor-stats-row mb-4">
          <Col lg={3} md={6} className="mb-3">
            <Card className="dl-donor-stat-card">
              <Card.Body>
                <div className="dl-stat-content-donor">
                  <div className="dl-stat-info-donor">
                    <h4 className="dl-stat-value-donor">{stats.totalDonors}</h4>
                    <p className="dl-stat-title-donor">Total Donors</p>
                  </div>
                  <div className="dl-stat-icon-wrapper-donor dl-total-donors-icon">
                    <Users size={24} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-3">
            <Card className="dl-donor-stat-card">
              <Card.Body>
                <div className="dl-stat-content-donor">
                  <div className="dl-stat-info-donor">
                    <h4 className="dl-stat-value-donor">{stats.activeDonors}</h4>
                    <p className="dl-stat-title-donor">Active Donors</p>
                  </div>
                  <div className="dl-stat-icon-wrapper-donor dl-active-donors-icon">
                    <TrendingUp size={24} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-3">
            <Card className="dl-donor-stat-card">
              <Card.Body>
                <div className="dl-stat-content-donor">
                  <div className="dl-stat-info-donor">
                    <h4 className="dl-stat-value-donor">{stats.inactiveDonors}</h4>
                    <p className="dl-stat-title-donor">Inactive Donors</p>
                  </div>
                  <div className="dl-stat-icon-wrapper-donor dl-inactive-donors-icon">
                    <Users size={24} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-3">
            <Card className="dl-donor-stat-card">
              <Card.Body>
                <div className="dl-stat-content-donor">
                  <div className="dl-stat-info-donor">
                    <h4 className="dl-stat-value-donor">PKR {stats.totalDonationsAmount.toLocaleString()}</h4>
                    <p className="dl-stat-title-donor">Total Donations</p>
                  </div>
                  <div className="dl-stat-icon-wrapper-donor dl-total-amount-icon">
                    <DollarSign size={24} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Search and Filter Section */}
        <Card className="dl-filter-card-donor mb-4">
          <Card.Body>
            <Row className="align-items-center">
              <Col lg={6} md={6} className="mb-3 mb-md-0">
                <InputGroup>
                  <InputGroup.Text className="dl-search-icon-donor">
                    <Search size={18} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search by name, email, or ID..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="dl-search-input-donor"
                  />
                </InputGroup>
              </Col>

              <Col lg={3} md={3} className="mb-3 mb-md-0">
                <InputGroup>
                  <InputGroup.Text className="dl-filter-icon-donor">
                    <Filter size={18} />
                  </InputGroup.Text>
                  <Form.Select
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    className="dl-filter-select-donor"
                  >
                    <option value="All">All Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </InputGroup>
              </Col>

              <Col lg={3} md={3}>
                <Button className="dl-export-donor-btn" onClick={handleExport}>
                  <Download size={18} />
                  Export CSV
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Donors Table */}
        <Card className="dl-donor-table-card">
          <Card.Body>
            <div className="dl-table-responsive table-responsive">
              <Table hover className="dl-donor-table">
                <thead>
                  <tr>
                    <th>Donor ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Total Donations</th>
                    <th>Level</th>
                    <th>No. of Donations</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentDonors.length > 0 ? (
                    currentDonors.map((donor) => (
                      <tr key={donor.id}>
                        <td className="dl-donor-id">{donor.id}</td>
                        <td className="dl-donor-name-table">{donor.name}</td>
                        <td className="dl-donor-email">{donor.email}</td>
                        <td className="dl-donor-amount">PKR {donor.totalDonations.toLocaleString()}</td>
                        <td>
                          <span className={`dl-level-badge ${getLevelBadge(donor.level)}`}>
                            {donor.level}
                          </span>
                        </td>
                        <td className="text-center">
                          <Badge bg="primary" className="dl-donations-count-badge">
                            {donor.numberOfDonations}
                          </Badge>
                        </td>
                        <td>
                          <Badge bg={getStatusBadge(donor.status)} className="dl-table-status-badge">
                            {donor.status}
                          </Badge>
                        </td>
                        <td>
                          {/* View Details Button */}
                          <button
                            className="dl-action-btn-donor dl-view-btn-donor"
                            onClick={() => handleViewDetails(donor)}
                            title="View Details"
                          >
                            <Eye size={16} />
                          </button>

                          {/* ✅ NEW: Toggle Status Button */}
                          <button
                            className={`dl-action-btn-donor ${donor.status === 'Active' ? 'dl-deactivate-btn' : 'dl-activate-btn'}`}
                            onClick={() => handleToggleStatus(donor.id)}
                            title={donor.status === 'Active' ? 'Deactivate Donor' : 'Activate Donor'}
                            style={{ marginLeft: '6px' }}
                          >
                            {donor.status === 'Active' ? <ToggleRight size={16} /> : <ToggleLeft size={16} />}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        <p className="dl-no-data-donor">No donors found</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {/* Pagination */}
            {!showAllDonors && filteredDonors.length > itemsPerPage && (
              <div className="dl-pagination-wrapper">
                <Pagination className="dl-custom-pagination">
                  <Pagination.Prev 
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  
                  {[...Array(totalPages)].map((_, index) => (
                    <Pagination.Item
                      key={index + 1}
                      active={index + 1 === currentPage}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))}
                  
                  <Pagination.Next 
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
                
                <div className="dl-pagination-info">
                  Showing {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, filteredDonors.length)} of {filteredDonors.length} donors
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>

      {/* Donor Detail Modal */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg" centered>
        <Modal.Header closeButton className="dl-modal-header-donor">
          <Modal.Title>Donor Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDonor && (
            <div className="dl-donor-details-modal">
              <Row>
                {/* Personal Information Section */}
                <Col md={12} className="mb-3">
                  <div className="dl-detail-section-header-donor">
                    <h5>Personal Information</h5>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <Users size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Donor ID</p>
                      <p className="dl-detail-value-donor">{selectedDonor.id}</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <Users size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Full Name</p>
                      <p className="dl-detail-value-donor">{selectedDonor.name}</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <Mail size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Email</p>
                      <p className="dl-detail-value-donor">{selectedDonor.email}</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <Phone size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Phone</p>
                      <p className="dl-detail-value-donor">{selectedDonor.phone}</p>
                    </div>
                  </div>
                </Col>

                <Col md={12} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <MapPin size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Address</p>
                      <p className="dl-detail-value-donor">{selectedDonor.address}</p>
                    </div>
                  </div>
                </Col>

                {/* Donation Information Section */}
                <Col md={12} className="mb-3 mt-3">
                  <div className="dl-detail-section-header-donor">
                    <h5>Donation Information</h5>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <DollarSign size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Total Donations</p>
                      <p className="dl-detail-value-donor dl-amount-highlight-donor">
                        PKR {selectedDonor.totalDonations.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <Award size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Donor Level</p>
                      <div>
                        <span className={`dl-level-badge-large ${getLevelBadge(selectedDonor.level)}`}>
                          {selectedDonor.level}
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <TrendingUp size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Number of Donations</p>
                      <p className="dl-detail-value-donor">{selectedDonor.numberOfDonations}</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <Calendar size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Joined Date</p>
                      <p className="dl-detail-value-donor">
                        {new Date(selectedDonor.joinedDate).toLocaleDateString('en-GB')}
                      </p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <Calendar size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Last Donation</p>
                      <p className="dl-detail-value-donor">
                        {new Date(selectedDonor.lastDonation).toLocaleDateString('en-GB')}
                      </p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <DollarSign size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Preferred Category</p>
                      <p className="dl-detail-value-donor">{selectedDonor.preferredCategory}</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <DollarSign size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Payment Method</p>
                      <p className="dl-detail-value-donor">{selectedDonor.paymentMethod}</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="dl-info-item-donor-modal">
                    <TrendingUp size={18} className="dl-info-icon-donor-modal" />
                    <div>
                      <p className="dl-detail-label-donor">Status</p>
                      <div>
                        <Badge bg={getStatusBadge(selectedDonor.status)} className="dl-status-badge-large">
                          {selectedDonor.status}
                        </Badge>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    </Adminlayout>
  );
};

export default DonorList;